export default __webpack_public_path__ + "i18n/translations/translation-ar.d9466af4.json";